import { DeviceStatus } from '@service-initiation/shared-clients-tech-care-services';

export const filterPortalAndWebsiteStatus = <
  T extends { status?: DeviceStatus }
>(
  records: T[] = []
) => {
  return records.filter(
    (record) =>
      record.status === undefined ||
      record.status === DeviceStatus.PortalAndWebsite
  );
};
